import type { AppGlueAny } from "../../AppGlueAny";
import { DataUtilities } from "../../DataUtilities";
import { IConfigStorage } from "../../IConfigStorage";

export class ExecutionData implements IConfigStorage {
    private _lockedData: { [name: string]: AppGlueAny } | undefined = undefined;

    constructor(data?: {}) {
        if (data) this.values = data;
    }

    private _values: { [name: string]: AppGlueAny } = {};

    get values(): { [name: string]: AppGlueAny } {
        if (this.datalocked) {
            return this._lockedData!;
        } else {
            return this._values;
        }
    }

    set values(data: { [name: string]: AppGlueAny }) {
        this._values = data;
    }

    get datalocked(): boolean {
        return !!this._lockedData;
    }

    set datalocked(locked: boolean) {
        if (locked) {
            this._lockedData = JSON.parse(JSON.stringify(this._values));
        } else {
            this._lockedData = undefined;
        }
    }

    getValueNames(): string[] {
        return Object.keys(this._values);
    }

    getStorageData(): object {
        let d = {};

        let dataValues = {};

        for (let k of Object.keys(this._values)) {
            Reflect.set(dataValues, k, this._values[k]);
        }

        Reflect.set(d, "dataValues", dataValues);

        if (this._lockedData) {
            let lockedData = {};

            for (let k of Object.keys(this._lockedData)) {
                Reflect.set(lockedData, k, this._lockedData[k]);
            }

            Reflect.set(d, "lockedDataValues", lockedData);
        }

        return d;
    }

    setStorageData(data: object): void {
        let values = Reflect.get(data, "dataValues");

        for (let k of Object.keys(values)) {
            this._values[k] = Reflect.get(values, k);
        }

        let lockedData = Reflect.get(data, "lockedDataValues");

        if (lockedData) {
            this._lockedData = {};

            for (let k of Object.keys(lockedData)) {
                this._lockedData[k] = Reflect.get(lockedData, k);
            }
        }
    }

    set(
        path: string,
        value: AppGlueAny,
        throwExceptionIfTargetIsNull: boolean = true,
        notCheckType: boolean = false,
        correctValues: boolean = false,
    ) {
        if (this.datalocked) throw new Error("Data is locked, cannot set");

        DataUtilities.set(this._values, path, value, throwExceptionIfTargetIsNull, notCheckType, correctValues);
    }

    get(path: string, defaultValue: AppGlueAny = undefined): AppGlueAny {
        return DataUtilities.get(this.values, path, defaultValue);
    }
}
